import { useMemo } from "react";
import useUserDashboardStatusData from "../../js/userDashBoradStatusData";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Image from "../../assets/image/index";
import { useDashboardCounts } from "../../actions/dashboardActions";
import { useUser } from "../../actions/authActions";
import { useEvents, useNews, usePortfolio } from "../../actions/homeActions";
import { useEmployer } from "../../actions/dashboardActions";
export default () => {
  const navigate = useNavigate();
  const localThumbnailImgurl = "uploads/events/thumbnail";
  const localTNewshumbnailImgurl = "uploads/news/thumbnail";
  const token = localStorage.getItem("accessToken");
  const userId = localStorage.getItem("userId");
  const user = useSelector((state) => state.app.userData.userData);
  const { data: userData } = useUser(userId);
  const { data: talentData } = usePortfolio(user?.talent?.id);
  const { data: employerData } = useEmployer(user?.employer?.id);
  const firstName = userData?.first_name ?? "";
  const lastName = userData?.last_name ?? "";
  const talentName = talentData?.real_name ?? "";
  const employerName = employerData?.name ?? "";

  // Determine the correct welcome name
  const welcomeName =
    user?.role === "fan"
      ? `${firstName} ${lastName}`.trim()
      : user?.role === "talent"
      ? talentName
      : user?.role === "employer"
      ? employerName
      : "";
  const baseURL = process.env.REACT_APP_BASE_URL;
  const { data: Events, isLoading, isError, error } = useEvents(1, 4);
  const {
    data: newsList,
    isLoading: newsisLoading,
    isError: newsisError,
    error: newsError,
  } = useNews(1, 4);
  const { data: dashboardCounts } = useDashboardCounts(
    userId,
    user?.role,
    user?.employer?.id
  );

  const userDashBoradStatusData = useUserDashboardStatusData();
  const updatedDashboardData = useMemo(() => {
    return userDashBoradStatusData.map((item) => {
      switch (item.title) {
        case user?.role === "employer" ? "Hire Request" : "Hiring Request":
          // Accessing the 'hire_me' property from the dashboardCounts data
          return { ...item, notification: dashboardCounts?.data?.hire_me || 0 };

        case user?.role === "employer" ? "Post Jobs" : "Jobs Applied":
          // Summing up 'job_apply' and 'saved_jobs' if they exist in dashboardCounts data
          return {
            ...item,
            notification: dashboardCounts?.data?.jobs ?? 0,
            // + (dashboardCounts?.data?.saved_jobs ?? 0)
          };
        case "Favourites":
          // Summing up 'job_apply' and 'saved_jobs' if they exist in dashboardCounts data
          return {
            ...item,
            notification: dashboardCounts?.data?.favourite_count ?? 0,
            // + (dashboardCounts?.data?.saved_jobs ?? 0)
          };

        default:
          return item;
      }
    });
  }, [dashboardCounts, user?.role, userDashBoradStatusData]);

  const handleEvents = (id) => {
    navigate(`/event-details/${id}`);
  };
  const formatEventDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };
  const handleNews = (id) => {
    navigate(`/news-details/${id}`);
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }

  if (newsisError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading news: {newsError.message}
        </p>
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  };
  const PromotionsSliderdata = [
    {
      id: 1,
      image: Image?.userDashBoradBannerImg,
    },
    {
      id: 2,
      image: Image?.userDashBoradBanner2Img,
    },
    {
      id: 3,
      image: Image?.userDashBoradBanner3Img,
    },
  ];
  const sliderSettings = {
    dots: false,
    infinite: newsList?.news?.length > 4,
    slidesToShow: newsList?.news?.length >= 4 ? 4 : newsList?.news?.length,
    slidesToScroll: 1,
    autoplay: newsList?.news?.length > 4,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    centerMode: false,
    variableWidth: false,
    className: newsList?.news?.length >= 4 ? "" : "sm:px-5 xl:px-10",
    responsive: [
      {
        breakpoint: 1660,
        settings: {
          slidesToShow:
            newsList?.news?.length >= 4 ? 4 : newsList?.news?.length,
          cssEase: "linear",
          infinite: newsList?.news?.length > 4,
          autoplay: newsList?.news?.length > 4,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: newsList?.news?.length >= 4 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow:
            newsList?.news?.length >= 3 ? 3 : newsList?.news?.length,
          cssEase: "linear",
          infinite: newsList?.news?.length > 3,
          autoplay: newsList?.news?.length > 3,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: newsList?.news?.length >= 3 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:
            newsList?.news?.length >= 2 ? 2.5 : newsList?.news?.length,
          cssEase: "linear",
          infinite: newsList?.news?.length > 2,
          autoplay: newsList?.news?.length > 2,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: newsList?.news?.length >= 2 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:
            newsList?.news?.length >= 2 ? 2 : newsList?.news?.length,
          cssEase: "linear",
          infinite: newsList?.news?.length > 2,
          autoplay: newsList?.news?.length > 2,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: newsList?.news?.length >= 2 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow:
            newsList?.news?.length >= 2 ? 2 : newsList?.news?.length,
          cssEase: "linear",
          pauseOnHover: true,
          infinite: newsList?.news?.length > 2,
          autoplay: newsList?.news?.length > 2,
          centerMode: false,
          variableWidth: true,
          slidesToScroll: 1,
          className: newsList?.news?.length === 1 ? "xs:px-3" : "",
        },
      },
    ],
  };
  const newsSliderSettings = {
    dots: false,
    infinite: Events?.events?.length > 4,
    slidesToShow: Events?.events?.length >= 4 ? 4 : Events?.events?.length,
    slidesToScroll: 1,
    autoplay: Events?.events?.length > 4,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    centerMode: false,
    variableWidth: false,
    className: Events?.events?.length >= 4 ? "" : "sm:px-5 xl:px-10",
    rtl: true,
    responsive: [
      {
        breakpoint: 1660,
        settings: {
          slidesToShow:
            Events?.events?.length >= 4 ? 4 : Events?.events?.length,
          cssEase: "linear",
          infinite: Events?.events?.length > 4,
          autoplay: Events?.events?.length > 4,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: Events?.events?.length >= 4 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow:
            Events?.events?.length >= 3 ? 3 : Events?.events?.length,
          cssEase: "linear",
          infinite: Events?.events?.length > 3,
          autoplay: Events?.events?.length > 3,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: Events?.events?.length >= 3 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:
            Events?.events?.length >= 2 ? 2.5 : Events?.events?.length,
          cssEase: "linear",
          infinite: Events?.events?.length > 2,
          autoplay: Events?.events?.length > 2,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: Events?.events?.length >= 2 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:
            Events?.events?.length >= 2 ? 2 : Events?.events?.length,
          cssEase: "linear",
          infinite: Events?.events?.length > 2,
          autoplay: Events?.events?.length > 2,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: Events?.events?.length >= 2 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow:
            Events?.events?.length >= 2 ? 2 : Events?.events?.length,
          cssEase: "linear",
          pauseOnHover: true,
          infinite: Events?.events?.length > 2,
          autoplay: Events?.events?.length > 2,
          centerMode: false,
          variableWidth: true,
          slidesToScroll: 1,
          className: Events?.events?.length === 1 ? "xs:px-3" : "",
        },
      },
    ],
  };
  return {
    localThumbnailImgurl,
    localTNewshumbnailImgurl,
    welcomeName,
    baseURL,
    Events,
    isLoading,
    newsList,
    newsisLoading,
    settings,
    PromotionsSliderdata,
    sliderSettings,
    newsSliderSettings,
    updatedDashboardData,
    formatEventDate,
    handleEvents,
    handleNews,
  };
};
